/* eslint-disable */
import moment from "moment";
import Flowit from "../../../services/flowit";
import * as types from "./types";

// eslint-disable-next-line no-unused-vars
export const hideFilters = ({ commit }) => {
  commit(types.FILTER_STATUS, false);
};

export const resetFilters = ({ commit }) => {
  commit(types.SET_FILTER_INITIAL_DATE,moment().startOf("month").format("YYYY-MM-DD"));
  commit(types.SET_FILTER_FINAL_DATE,moment().endOf("month").format("YYYY-MM-DD"));
  commit(types.SET_FILTER_PAYMENT_INITIAL_DATE, moment().startOf("year").format("YYYY-MM-DD"));
  commit(types.SET_FILTER_PAYMENT_FINAL_DATE, moment().endOf("year").format("YYYY-MM-DD") );
  commit(types.SET_FILTER_CARD_BRAND, "");
  commit(types.SET_FILTER_TERMINAL_NUMBER, "");
  commit(types.SET_FILTER_STATUS, "");
  commit(types.SET_FILTER_OPERATION, "");
  commit(types.SET_FILTER_ORDINATION, "");
  commit(types.FILTER_PARAMS, {
      page: 1,
      limit: 10,
      filterrific: {
        with_created_at_between: {
          start_at: null,
          end_at: null,
        },
        status: null,
        credit_card_brand: null,
        with_terminal_number: null,
        operation: null,
        with_partner: null,
        sorted_by: null,
        with_account_id: null
      }
    } 
  );
};

/* eslint-disable */
export const load = ({ commit, state }, params) => {
  commit(types.LOADING_DATA, true);
  commit(types.SET_PARTNER_PAYMENTS_LIST, []);
  Flowit.partners_payments
  .list(state.filterParams)
    .then(response => {
      commit(types.SET_PARTNER_PAYMENTS_LIST, response.data.payments);
      commit(types.SET_TOTAL_RESOURCES, response.data.resources);
      commit(types.SET_PARTNER_PAYMENTS_SUBTOTAL, response.data.subtotal);
      commit(types.SET_PARTNER_PAYMENTS_SUMMARY, {
        transacted_total: response.data.transacted_total,
        settled_total: response.data.settled_total,
        devices_count: response.data.devices_count,
      });
      commit(types.CURRENT_PAGE, response.data.page);
      commit(types.LIMIT, response.data.limit);
      commit(types.LOADING_DATA, false);
    })
    .catch(error => {
      // console.log("Error: " + error);
      commit(types.ERRORS, error);
      commit(types.SHOW_ERROR, true);
      commit(types.LOADING_DATA, false);
    });
};

// eslint-disable-next-line no-unused-vars
export const get = ({ commit }, accountId) => {
  commit(types.LOADING_DATA, true);
  Flowit.partners_payments.get(accountId).then(response => {
    commit(types.SET_PARTNER_PAYMENT_DATA, response.data);
    commit(types.LOADING_DATA, false);
  });
};

// eslint-disable-next-line no-unused-vars
export const exportPayments = ({ commit }, params) => {
  commit(types.LOAD, true);
  Flowit.partners_payments.exportPayments(params).then(response => {});
  commit(types.LOAD, false);
};

export const newPayment = ({ commit }, params) => {
  commit(types.LOAD, true);
  commit(types.SUCCESS_STATUS, false);
  commit(types.ERROR_STATUS, false);
  Flowit.partners_payments.newPayment(params).then(
    response => {
      commit(types.NEW_PAYMENT_RESPONSE, response.data.partners_payment);
      commit(types.SUCCESS_STATUS, true);
      commit(types.LOAD, false);
    },
    error => {
      commit(types.ERROR_STATUS, true);
      commit(types.ERROR_MESSAGE, error.response.data.message);
      commit(types.LOAD, false);
    }
  );
};

export const updateSubscription = ({ commit }, params) => {
  commit(types.LOADING_DATA, true);
  commit(types.NEW_PAYMENT_STATUS, false);
  commit(types.NEW_PAYMENT_ERROR, false);
  Flowit.partners_payments
    .updateSubscription(params)
    .then(response => {
      commit(types.UPDATE_SUBSCRIPTION, response.data.subscription);
      commit(types.NEW_PAYMENT_STATUS, true);
      commit(types.NEW_PAYMENT_ERROR, false);
      commit(types.LOADING_DATA, false);
    })
    .catch(error => {
      // console.log(error);
      commit(types.UPDATE_SUBSCRIPTION, error.response.data);
      commit(types.NEW_PAYMENT_ERROR, true);
      commit(types.NEW_PAYMENT_STATUS, false);
      commit(types.LOADING_DATA, false);
    });
};

export const loadFilters = ({ commit }) => {
  commit(
    types.SET_FILTER_INITIAL_DATE,
    moment()
      .startOf("year")
      .format("YYYY-MM-DD")
  );
  commit(
    types.SET_FILTER_FINAL_DATE,
    moment()
      .endOf("year")
      .format("YYYY-MM-DD")
  );
  commit(types.SET_FILTER_PAYMENT_INITIAL_DATE, null);
  commit(types.SET_FILTER_PAYMENT_FINAL_DATE, null);
  commit(types.LIMIT, 1000);
};

// eslint-disable-next-line no-unused-vars
export const setInitialDate = ({ commit }, date) => {
  commit(types.SET_FILTER_INITIAL_DATE, date);
};
// eslint-disable-next-line no-unused-vars
export const setFinalDate = ({ commit }, date) => {
  commit(types.SET_FILTER_FINAL_DATE, date);
};
// eslint-disable-next-line no-unused-vars
export const setPaymentInitialDate = ({ commit }, date) => {
  commit(types.SET_FILTER_PAYMENT_INITIAL_DATE, date);
};
// eslint-disable-next-line no-unused-vars
export const setPaymentFinalDate = ({ commit }, date) => {
  commit(types.SET_FILTER_PAYMENT_FINAL_DATE, date);
};

export const setCardBrand = ({ commit }, cardBrand) => {
  commit(types.SET_FILTER_CARD_BRAND, cardBrand);
};

export const setTerminalNumber = ({ commit }, terminalNumber) => {
  commit(types.SET_FILTER_TERMINAL_NUMBER, terminalNumber);
};

export const setStatus = ({ commit }, model) => {
  commit(types.SET_FILTER_STATUS, model.business);
};
export const setOperation = ({ commit }, operation) => {
  commit(types.SET_FILTER_OPERATION, operation.business);
};
export const setOrdination = ({ commit }, ordination) => {
  commit(types.SET_FILTER_ORDINATION, ordination.business);
};

export const setCurrentPage = ({ commit }, param) => {
  commit(types.CURRENT_PAGE, param);
};

export const setTotalResources = ({ commit }, total) => {
  commit(types.SET_TOTAL_RESOURCES, total);
};

export const setLimit = ({ commit }, param) => {
  commit(types.LIMIT, param);
};

export const setLoadingData = ({ commit }, param) => {
  commit(types.LOADING_DATA, param);
};

export const showFilters = ({ commit }, param) => {
  commit(types.SHOW_FILTERS, param);
};

export const setPartner = ({ commit }, model) => {
  commit(types.SET_FILTER_PARTNER, model.business);
};
export const setStartAt = ({ commit }, param) => {
  state.filterParams.filterrific.with_created_at_between.start_at = param;
};

export const loadList = ({ commit }, params) => {
  commit(types.LOAD, true);
  commit(types.SUCCESS_STATUS, false);
  commit(types.ERROR_STATUS, false);
  Flowit.partners_payments
    .loadList(params)
    .then(response => {
      commit(types.LOAD_LIST, response.data.partners_payments);
      commit(types.LOAD, false);
    })
    .catch(error => {
      commit(types.ERROR_STATUS, true);
      commit(types.ERROR_MESSAGE, error.response.data.message);
      commit(types.LOAD, false);
    });
};

export const getPayment = ({ commit }, paymentId) => {
  commit(types.LOAD, true);
  commit(types.SUCCESS_STATUS, false);
  commit(types.ERROR_STATUS, false);
  Flowit.partners_payments.get(paymentId).then(response => {
    commit(types.GET_PAYMENT, response.data.partners_payment);
    commit(types.LOAD, false);
  });
};

export const loadListSubscriptions = ({ commit }, params) => {
  commit(types.LOAD, true);
  commit(types.SUCCESS_STATUS, false);
  commit(types.ERROR_STATUS, false);
  Flowit.partners_payments
    .loadListSubscriptions(params)
    .then(response => {
      commit(types.LOAD_LIST_SUBSCRIPTIONS, response.data.subscriptions);
      commit(types.LOAD, false);
    })
    .catch(error => {
      commit(types.ERROR_STATUS, true);
      commit(types.ERROR_MESSAGE, error.response.data.message);
      commit(types.LOAD, false);
    });
};
